<!--
 * @Author: 5CD2160XDH\shijun shijun1@haosen.com.cn
 * @Date: 2024-05-09 11:13:10
 * @LastEditors: 5CD2160XDH\shijun shijun1@haosen.com.cn
 * @LastEditTime: 2024-05-27 13:30:34
 * @FilePath: \hszy-official-website\src\views\FreeTrialPhone\index.vue
 * @Description: 免费体验
-->
<template>
  <div class="hidden-lg-and-up">
    <div class="wrapper">
      <div class="top"><div class="back" @click="handleJumpByUrl('/')" /><span>免费体验</span></div>
      <Form ref="form" :rules="rules" :model="form" label-position="left" label-width="80px">
        <FormItem prop="phone" label="手机号">
          <Input v-model="form.phone" placeholder="请输入手机号（必填）" prefix-icon="el-icon-cellphone" class="custom-phone" />
        </FormItem>
        <FormItem prop="name" label="姓名">
          <Input v-model="form.name" placeholder="请输入姓名" prefix-icon="el-icon-name" class="custom-name" />
        </FormItem>
        <FormItem prop="company" label="企业名称">
          <Input v-model="form.company" placeholder="请输入企业名称" prefix-icon="el-icon-enterprise" class="custom-enterprise" />
        </FormItem>
        <FormItem prop="position" label="职位">
          <Input v-model="form.position" placeholder="请输入职位" prefix-icon="el-icon-duty" class="custom-duty" />
        </FormItem>
        <FormItem prop="industry" label="行业">
          <Input v-model="form.industry" placeholder="请输入所在行业" prefix-icon="el-icon-industry" class="custom-industry" />
        </FormItem>
        <!-- <Button type="primary" style="width: 440px;height: 48px;" @click="handleSubmit">提交</Button> -->
      </Form>
      <div class="submit" @click="handleSubmit">提交</div>
    </div>
  </div>
</template>
<script>
import { Form, FormItem, Input, Message } from 'element-ui'
// import { Row } from 'element-ui'
import { saveFreeExperience } from '../../api'
export default {
  name: 'FreeTrialForm',
  components: {
    Form,
    FormItem,
    Input
  },
  data() {
    return {
      labelPosition: 'left',
      form: {},
      rules: {
        name: [
          { pattern: /^[\u4e00-\u9fa5]{0,}$/, message: '请输入正确的姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          { pattern: /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/, message: '请输入正确的电话', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleJumpByUrl(url) {
      this.$router.push({ path: url })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          saveFreeExperience({ ...this.form }).then(_ => {
            Message({
              showClose: true,
              message: '保存成功',
              type: 'success'
            })
            this.$refs.form.resetFields()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.wrapper {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  .top {
    box-sizing: border-box;
    width: 100%;
    height: 88px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    background-color: #3d3491;
    color: #fff;
    font-size: 36px;
    .back {
      position: absolute;
      left: 30px;
      width: 20px;
      height: 20px;
      border: 2px solid #fff;
      border-left: 2px solid transparent;
      border-bottom: 2px solid transparent;
      transform: rotate(-135deg);
      cursor: pointer;
    }
  }
  /deep/ .el-form {
    margin-top: 30px;
    width: 90%;
    .el-form-item {
      margin-bottom: 17px;
    }
    .el-form-item__content {
      margin-left: 160px !important;
      align-items: center;
      line-height: 70px;
    }
    .el-input {
      font-size: 18px;
    }
    .el-input__inner {
      height: 70px;
      line-height: 70px;
    }
    .el-input--prefix .el-input__inner {
      font-size: 28px;
      padding-left: 18px;
    }
  }
  /deep/ .el-form--label-left .el-form-item__label {
    line-height: 70px;
    font-size: 28px;
    width: 140px !important;
  }
  .submit {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    height: 88px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    background-color: #3d3491;
    color: #fff;
    font-size: 32px;
  }
}
@media screen and (max-width: 1200px) {
  .wrapper {
    height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .top {
      box-sizing: border-box;
      width: 100%;
      height: 44px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 0 35px;
      background-color: #3d3491;
      color: #fff;
      font-size: 18px;
      .back {
        position: absolute;
        left: 15px;
        width: 10px;
        height: 10px;
        border: 2px solid #fff;
        border-left: 2px solid transparent;
        border-bottom: 2px solid transparent;
        transform: rotate(-135deg);
        cursor: pointer;
      }
    }
    /deep/ .el-form {
      margin-top: 15px;
      width: 90%;
      .el-form-item {
        margin-bottom: 17px;
      }
      .el-form-item__content {
        margin-left: 80px !important;
        align-items: center;
        line-height: 35px;
      }
      .el-input {
        font-size: 9px;
      }
      .el-input__inner {
        height: 35px;
        line-height: 35px;
      }
      .el-input--prefix .el-input__inner {
        font-size: 14px;
        padding-left: 9px;
      }
    }
    /deep/ .el-form--label-left .el-form-item__label {
      line-height: 35px;
      font-size: 14px;
      width: 70px !important;
    }
    .submit {
      position: absolute;
      bottom: 0;
      box-sizing: border-box;
      width: 100%;
      height: 44px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      background-color: #3d3491;
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>
